import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const { t, i18n } = useTranslation('common');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'pt' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-600 rounded-lg">
              <i className="ri-scales-3-line text-2xl text-white"></i>
            </div>
            <div>
              <h1 className="text-lg font-bold text-gray-900" style={{ color: isScrolled ? '#1a1a1a' : '#ffffff' }}>
                ARIEIRA ARAUJO
              </h1>
              <p className="text-xs text-gray-600" style={{ color: isScrolled ? '#666' : '#e5e5e5' }}>
                ADVOGADOS
              </p>
            </div>
          </div>
          
          <div className="flex items-center gap-8">
            <a 
              href="#about" 
              className="text-sm font-medium hover:text-amber-600 transition-colors cursor-pointer"
              style={{ color: isScrolled ? '#1a1a1a' : '#ffffff' }}
            >
              {t('nav.about')}
            </a>
            <a 
              href="#partners" 
              className="text-sm font-medium hover:text-amber-600 transition-colors cursor-pointer"
              style={{ color: isScrolled ? '#1a1a1a' : '#ffffff' }}
            >
              {t('nav.partners')}
            </a>
            <a 
              href="#practice" 
              className="text-sm font-medium hover:text-amber-600 transition-colors cursor-pointer"
              style={{ color: isScrolled ? '#1a1a1a' : '#ffffff' }}
            >
              {t('nav.practice')}
            </a>
            <a 
              href="#contact" 
              className="text-sm font-medium hover:text-amber-600 transition-colors cursor-pointer"
              style={{ color: isScrolled ? '#1a1a1a' : '#ffffff' }}
            >
              {t('nav.contact')}
            </a>
            
            <button
              onClick={toggleLanguage}
              className="flex items-center gap-2 px-4 py-2 rounded-full border transition-all cursor-pointer text-sm font-medium whitespace-nowrap"
              style={{
                borderColor: isScrolled ? '#d1d5db' : 'rgba(255,255,255,0.3)',
                color: isScrolled ? '#1a1a1a' : '#ffffff',
                backgroundColor: isScrolled ? 'transparent' : 'rgba(255,255,255,0.1)'
              }}
            >
              <i className="ri-global-line text-base"></i>
              {i18n.language === 'en' ? 'PT' : 'EN'}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
